module.exports = __webpack_public_path__ + "static/media/users_icon_dark.f953c08c.png";